import { SEGMENT_BUILDER_TOUR } from "./segmentBuilderTour";
import { useSegmentTourPromo } from "./useSegmentTourPromo";

import { TourPromoCard } from "@/features/tours/components/TourPromoCard";

export function SegmentTourHomeCard() {
  const { showHomeCard, dismissCard, startTour } = useSegmentTourPromo();

  if (!showHomeCard) return null;

  return (
    <TourPromoCard
      copyKey={`${SEGMENT_BUILDER_TOUR.copyKey}.homeCard`}
      onStart={startTour}
      onDismiss={dismissCard}
    />
  );
}
